
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import MenuPage from '../pages/menu/page';
import NotFound from '../pages/NotFound';
import ReservationsPage from '../pages/reservations/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/menu',
    element: <MenuPage />
  },
  {
    path: '/prenotazioni',
    element: <ReservationsPage />
  },
  {
    path: '*',
    element: <NotFound />
  },
];

export default routes;
